/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import React  from 'react';
import styles from './index.module.less';
import classNames from 'classnames';
import type { ILinkProps } from '@/deps/web';
interface INewLink extends Omit<ILinkProps, 'icon'> {
    iconClassName?: string;
    onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
    icon?: React.ReactNode;
}

const LinkIcon: React.FC<{ className?: string; }> = (props) => {
    return (
        <span className={ props.className ?? styles.linkIcon }>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                version="1.1"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
            >
                <defs>
                    <clipPath
                        id="master_svg0_692_11810"
                    >
                        <rect
                            x="24"
                            y="24"
                            width="100%"
                            height="100%"
                            rx="0"
                        />
                    </clipPath>
                </defs>
                <g
                    transform="matrix(-1,-5.2146120310681e-8,5.2146120310681e-8,-1,47.99999874849305,48.00000375452066)"
                    clipPath="url(#master_svg0_692_11810)"
                >
                    <g transform="matrix(0,1,-1,0,67.99987918119439,-13.414183318805613)">
                        <path
                            d="M58.12123125,28.707057931194388L49.41414125,37.414147931194385L40.70703125,28.707057931194388L42.12124125,27.292847931194387L49.41414125,34.58573793119439L56.70703125,27.292847931194387L58.12123125,28.707057931194388Z"
                            fillRule="evenodd"
                            fill="currentColor"
                            fillOpacity="1"
                        />
                    </g>
                </g>
            </svg>
        </span>
    );
};

export const NewLink: React.FC<INewLink> = (props) => {
    return (
        <span
            className={ classNames(styles.newLink, props.className) }
            onClick={ props.onClick }
        >
            <a
                target={ props.target }
                rel={ `${props.noreferrer ? 'noreferrer' : ''} ${props.nofollow ? 'nofollow' : ''}` }
                href={ props.href ?? '' }
            >
                {props.text}
            </a>
            {
                (props.icon || props.icon === null) ? (
                    props.icon
                ) : (
                    <LinkIcon className={ props.iconClassName } />
                )
            }
            
        </span>
    );
};
